"use client";

import { Spinner } from "@/components/ui/spinner";

import { useButton, type UseButtonProps } from "./use-button";

export type ButtonProps = UseButtonProps;
function Button(props: ButtonProps) {
  const {
    className,
    children,
    styles,
    loadingLabel,
    hide,
    componentProps,
    isLoading,
    Component,
  } = useButton(props);

  if (hide) return null;

  return (
    <Component {...componentProps} className={styles.base({ className })}>
      {isLoading ? (
        <Spinner className={styles.loading()} label={loadingLabel} />
      ) : (
        children
      )}
    </Component>
  );
}

export default Button;
